





















import {
  defineComponent, computed,
} from '@vue/composition-api';

import IncomeStats from '@/components/Report/Lite/IncomeStats.vue';
import ChartWithLastYearCompare from '@/components/Report/ChartWithLastYearCompare.vue';

import monthsIncome from '@/gql/managementReport/01-Income/monthsIncome.gql';

const DeliveryIncomeByMonth = defineComponent({
  components: {
    IncomeStats,

    ChartWithLastYearCompare,
  },
  setup() {
    const computedPrimaryColor = computed(() => getComputedStyle(document.documentElement).getPropertyValue('--color-primary-500'));
    const computedSecondaryColor = computed(() => getComputedStyle(document.documentElement).getPropertyValue('--color-primary-300'));

    return {
      computedPrimaryColor,
      computedSecondaryColor,
      monthsIncome,
    };
  },
});

export default DeliveryIncomeByMonth;
